export default (props: {e164: string; shortNumber: string}) => {
    return <span>{props.e164 === "" ? props.shortNumber : props.e164}</span>;
};
